// extracted by mini-css-extract-plugin
export default {"VLDropdown":"VLDropdown_VLDropdown__V9PUE"};